export default function removeSelectedPassengerFromPreviousGroup(passengerIdsGroup: number[], passengerId: number) {
    if (passengerIdsGroup.includes(passengerId)) {
        passengerIdsGroup.splice(passengerIdsGroup.indexOf(passengerId), 1)
    }

    return passengerIdsGroup
}